export const DDynamicTextStyleWordWrap = wcardinal.ui.DDynamicTextStyleWordWrap;